import { createStore } from "vuex";

export default createStore({
  state: {
    hideConfigButton: false,
    showConfig: false,
    sidebarType: "bg-gradient-dark",
    isRTL: false,
    mcolor: "",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isDarkMode: false,
    tenantName: null,
  },
  mutations: {
    setTenantName(state, tenantName) {
      state.tenantName = tenantName;
    },

    unsetAll(state) {
      state.tenantName = null;
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
  },
  getters: {},
});
